export default function toPDFMakeData(props: any) {
  return {
    defaultStyle: {
      font: `THSarabunNew`,
    },
    content: [
      {
        alignment: `center`,
        text: `Medical Certificate`,
        preserveLeadingSpaces: true,
        fontSize: `18`,
        bold: true,
        width: `auto`,
        decorationColor: ``,
        decoration: ``,
        color: ``,
        decorationStyle: ``,
        pageBreak: ``,
      },
      {
        bold: `true`,
        preserveLeadingSpaces: true,
        alignment: `center`,
        color: ``,
        decoration: ``,
        decorationColor: ``,
        pageBreak: ``,
        width: `auto`,
        decorationStyle: ``,
        text: `COVID-19 Quarantine Completion`,
        fontSize: `18`,
      },
      {
        fontSize: 15,
        pageBreak: ``,
        width: `auto`,
        color: ``,
        decorationStyle: ``,
        text: ` `,
        bold: false,
        decoration: ``,
        preserveLeadingSpaces: true,
        alignment: `left`,
        decorationColor: ``,
      },
      {
        columns: [
          {
            decoration: ``,
            decorationStyle: ``,
            alignment: `left`,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
            bold: false,
            text: ``,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            width: 400,
          },
          {
            color: ``,
            decoration: ``,
            fontSize: 15,
            pageBreak: ``,
            decorationColor: ``,
            alignment: `left`,
            preserveLeadingSpaces: true,
            width: `auto`,
            decorationStyle: ``,
            text: `Date ${props.items?.formatCreatedDate}`,
            bold: true,
          },
        ],
      },
      {
        columns: [
          {
            decoration: ``,
            width: 40,
            alignment: `left`,
            color: ``,
            text: ``,
            decorationColor: ``,
            bold: false,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
          },
          {
            preserveLeadingSpaces: true,
            decorationColor: ``,
            decoration: ``,
            decorationStyle: ``,
            bold: false,
            alignment: `left`,
            width: `auto`,
            fontSize: 15,
            text: `This is certify that `,
            color: ``,
            pageBreak: ``,
          },
          {
            pageBreak: ``,
            alignment: `left`,
            fontSize: 15,
            preserveLeadingSpaces: true,
            width: 10,
            decoration: ``,
            color: ``,
            bold: false,
            decorationStyle: ``,
            text: ``,
            decorationColor: ``,
          },
          {
            stack: [
              {
                width: `auto`,
                color: ``,
                text: `${
                  props.items.patientInfo?.full_name_en !== ""
                    ? props.items?.patientInfo?.full_name_en
                    : props.items?.patientInfo?.full_name_th !== ""
                    ? props.items?.patientInfo?.full_name_th
                    : props.items?.patientInfo?.full_name
                }`,
                decoration: ``,
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decorationColor: ``,
                bold: false,
                fontSize: 15,
                alignment: `left`,
                pageBreak: ``,
                margin: [0, 0, 0, -15],
              },
              {
                color: ``,
                bold: false,
                margin: [0, 0, 0, 0],
                fontSize: 15,
                width: `auto`,
                text: `........................................................................................................................................................`,
                alignment: `left`,
                preserveLeadingSpaces: true,
                decorationColor: ``,
                pageBreak: ``,
                decoration: ``,
                decorationStyle: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            alignment: `left`,
            text: `Identification / Passport number / Other `,
            bold: false,
            color: ``,
            fontSize: 15,
            pageBreak: ``,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decoration: ``,
          },
          {
            fontSize: 15,
            alignment: `left`,
            decoration: ``,
            width: 10,
            text: ``,
            color: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            bold: false,
            pageBreak: ``,
            decorationColor: ``,
          },
          {
            stack: [
              {
                decoration: ``,
                alignment: `left`,
                bold: false,
                decorationColor: ``,
                fontSize: 15,
                color: ``,
                width: `auto`,
                text:
                  props.items?.patientInfo?.citizen_no === "" ||
                  props.items?.patientInfo?.citizen_no === "Non citizen identity"
                    ? props.items?.patientInfo?.citizen_passport === "" ||
                      props.items?.patientInfo?.citizen_passport === "Non citizen identity"
                      ? " "
                      : props.items?.patientInfo?.citizen_passport
                    : props.items?.patientInfo?.citizen_no,
                margin: [0, 0, 0, -15],
                decorationStyle: ``,
                pageBreak: ``,
                preserveLeadingSpaces: true,
              },
              {
                decorationColor: ``,
                preserveLeadingSpaces: true,
                width: `auto`,
                color: ``,
                text: `...............................................................................................................................`,
                margin: [0, 0, 0, 0],
                alignment: `left`,
                fontSize: 15,
                pageBreak: ``,
                bold: false,
                decoration: ``,
                decorationStyle: ``,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: `auto`,
            text: `Age `,
            preserveLeadingSpaces: true,
            fontSize: 15,
            pageBreak: ``,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            decorationColor: ``,
            alignment: `left`,
            bold: false,
          },
          {
            width: 10,
            color: ``,
            alignment: `left`,
            fontSize: 15,
            decorationColor: ``,
            decorationStyle: ``,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            text: ``,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                margin: [0, 0, 0, -15],
                alignment: `left`,
                bold: false,
                decoration: ``,
                decorationStyle: ``,
                decorationColor: ``,
                color: ``,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                width: `auto`,
                text: `${props.items?.ageYear} years ${props.items?.ageMonth} months ${props.items?.ageDay} days`,
              },
              {
                text: `............................................................................`,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
                decoration: ``,
                color: ``,
                decorationColor: ``,
                bold: false,
                fontSize: 15,
                decorationStyle: ``,
                pageBreak: ``,
                alignment: `left`,
                width: `auto`,
              },
            ],
          },
          {
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            color: ``,
            text: `Hospital Number`,
            pageBreak: ``,
            decorationStyle: ``,
            fontSize: 15,
            alignment: `left`,
            width: `auto`,
            bold: false,
          },
          {
            decoration: ``,
            width: 10,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
            text: ``,
            decorationColor: ``,
            pageBreak: ``,
            color: ``,
            bold: false,
            preserveLeadingSpaces: true,
          },
          {
            stack: [
              {
                bold: false,
                width: `auto`,
                fontSize: 15,
                decoration: ``,
                decorationColor: ``,
                decorationStyle: ``,
                pageBreak: ``,
                color: ``,
                alignment: `left`,
                preserveLeadingSpaces: true,
                text: props.items?.patientInfo?.hn,
                margin: [0, 0, 0, -15],
              },
              {
                bold: false,
                margin: [0, 0, 0, 0],
                decoration: ``,
                color: ``,
                decorationColor: ``,
                decorationStyle: ``,
                pageBreak: ``,
                text: `..............................................................................`,
                fontSize: 15,
                preserveLeadingSpaces: true,
                alignment: `left`,
                width: `auto`,
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            alignment: `left`,
            decoration: ``,
            decorationColor: ``,
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            width: `auto`,
            color: ``,
            fontSize: 15,
            text: `had history of present illness : RT-PCR for COVID-19 detected on`,
            pageBreak: ``,
            bold: false,
          },
          {
            decorationStyle: ``,
            decoration: ``,
            text: ``,
            preserveLeadingSpaces: true,
            bold: false,
            width: 10,
            fontSize: 15,
            alignment: `left`,
            decorationColor: ``,
            color: ``,
            pageBreak: ``,
          },
          {
            stack: [
              {
                fontSize: 15,
                decorationColor: ``,
                color: ``,
                margin: [0, 0, 0, -15],
                bold: false,
                decoration: ``,
                alignment: `left`,
                pageBreak: ``,
                preserveLeadingSpaces: true,
                text: props.items?.detectDate,
                width: `auto`,
                decorationStyle: ``,
              },
              {
                bold: false,
                decoration: ``,
                text: `..................................................................................`,
                pageBreak: ``,
                fontSize: 15,
                margin: [0, 0, 0, 0],
                preserveLeadingSpaces: true,
                decorationStyle: ``,
                decorationColor: ``,
                alignment: `left`,
                color: ``,
                width: `auto`,
              },
            ],
          },
        ],
      },
      {
        width: `auto`,
        decorationStyle: ``,
        decoration: ``,
        decorationColor: ``,
        color: ``,
        pageBreak: ` `,
        text: ` `,
        preserveLeadingSpaces: true,
        alignment: `left`,
        bold: false,
        fontSize: 15,
      },
      {
        fontSize: 15,
        decoration: ``,
        alignment: `left`,
        decorationStyle: ``,
        preserveLeadingSpaces: true,
        bold: false,
        color: ``,
        text: `Patient has completed the treatment / quarantine according to the Thai the Ministry of Public Health recommendations.`,
        decorationColor: ``,
        width: `auto`,
        pageBreak: ``,
      },
      {
        color: ``,
        decoration: ``,
        decorationStyle: ``,
        bold: false,
        alignment: `left`,
        fontSize: 15,
        pageBreak: ``,
        width: `auto`,
        text: ` `,
        preserveLeadingSpaces: true,
        decorationColor: ``,
      },
      {
        text: `Summary and / or Recommendation`,
        color: ``,
        decorationColor: ``,
        width: `auto`,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        decoration: ``,
        fontSize: 15,
        bold: `true`,
        alignment: `left`,
      },
      {
        bold: false,
        alignment: `left`,
        decorationColor: ``,
        fontSize: 15,
        width: `auto`,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        decoration: ``,
        text: `Post COVID-19 infection: Recovered by clinical condition. Advise mask wearing , hand cleaning, social distancing and avoidance of crowded place.`,
        decorationStyle: ``,
        color: ``,
      },
      {
        decoration: ``,
        fontSize: 15,
        bold: false,
        pageBreak: ``,
        text: ` `,
        decorationColor: ``,
        width: `auto`,
        alignment: `left`,
        preserveLeadingSpaces: true,
        color: ``,
        decorationStyle: ``,
      },
      {
        columns: [
          {
            width: `auto`,
            preserveLeadingSpaces: true,
            decoration: ``,
            decorationColor: ``,
            pageBreak: ``,
            color: ``,
            text: `Other Recommendation :`,
            bold: `true`,
            fontSize: 15,
            decorationStyle: ``,
            alignment: `left`,
          },
          {
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            text: ``,
            pageBreak: ``,
            alignment: `left`,
            width: 10,
            bold: false,
            decorationColor: ``,
          },
          {
            stack: [
              {
                bold: false,
                width: `auto`,
                decorationStyle: ``,
                margin: [0, 0, 0, -15],
                color: ``,
                pageBreak: ``,
                text:
                  props.items?.comment == null || props.items?.comment === ""
                    ? " "
                    : props.items?.comment,
                decoration: ``,
                preserveLeadingSpaces: true,
                fontSize: 15,
                alignment: `left`,
                decorationColor: ``,
              },
              {
                decoration: ``,
                decorationColor: ``,
                text: `........................................................................................................................................................`,
                decorationStyle: ``,
                preserveLeadingSpaces: true,
                bold: false,
                width: `auto`,
                fontSize: 15,
                margin: [0, 0, 0, 0],
                pageBreak: ``,
                color: ``,
                alignment: `left`,
              },
            ],
          },
        ],
      },
      {
        pageBreak: ``,
        color: ``,
        fontSize: 15,
        margin: [0, 0, 0, 0],
        bold: false,
        preserveLeadingSpaces: true,
        text: `..............................................................................................................................................................................................................`,
        decorationStyle: ``,
        width: `auto`,
        decorationColor: ``,
        decoration: ``,
        alignment: `left`,
      },
      {
        decorationStyle: ``,
        bold: false,
        margin: [0, 0, 0, 0],
        text: `..............................................................................................................................................................................................................`,
        fontSize: 15,
        color: ``,
        preserveLeadingSpaces: true,
        decoration: ``,
        alignment: `left`,
        pageBreak: ``,
        width: `auto`,
        decorationColor: ``,
      },
      {
        color: ``,
        pageBreak: ``,
        alignment: `left`,
        decorationColor: ``,
        width: `auto`,
        bold: false,
        text: ` `,
        fontSize: 15,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        decoration: ``,
      },
      {
        columns: [
          {
            pageBreak: ``,
            color: ``,
            decorationStyle: ``,
            decoration: ``,
            width: `auto`,
            fontSize: 15,
            preserveLeadingSpaces: true,
            text: `Patient required period of absence for`,
            alignment: `left`,
            decorationColor: ``,
            bold: false,
          },
          {
            alignment: `left`,
            bold: false,
            width: 10,
            text: ``,
            decorationStyle: ``,
            color: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            decorationColor: ``,
            decoration: ``,
            pageBreak: ``,
          },
          {
            stack: [
              {
                text: props.items?.absenceDuration ? props.items?.absenceDuration : " ",
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `center`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `....................`,
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `left`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
            width: `auto`,
          },
          {
            preserveLeadingSpaces: true,
            pageBreak: ``,
            bold: false,
            decorationStyle: ``,
            color: ``,
            alignment: `left`,
            decoration: ``,
            text: ``,
            fontSize: 15,
            decorationColor: ``,
            width: 10,
          },
          {
            alignment: `left`,
            bold: false,
            pageBreak: ``,
            decoration: ``,
            preserveLeadingSpaces: true,
            color: ``,
            decorationStyle: ``,
            text: `days             from`,
            width: `auto`,
            decorationColor: ``,
            fontSize: 15,
          },
          {
            text: ``,
            preserveLeadingSpaces: true,
            decorationStyle: ``,
            decorationColor: ``,
            decoration: ``,
            bold: false,
            pageBreak: ``,
            color: ``,
            margin: [0, 0, 0, 0],
            alignment: `left`,
            fontSize: 15,
            width: 10,
          },
          {
            stack: [
              {
                text: props.items?.absenceStartDate ? props.items?.absenceStartDate : " ",
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `center`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `.........................`,
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `left`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
            width: `auto`,
          },
          {
            decorationStyle: ``,
            fontSize: 15,
            alignment: `left`,
            pageBreak: ``,
            width: 10,
            bold: false,
            color: ``,
            decoration: ``,
            decorationColor: ``,
            text: ``,
            preserveLeadingSpaces: true,
          },
          {
            decoration: ``,
            preserveLeadingSpaces: true,
            text: `to`,
            width: `auto`,
            alignment: `left`,
            fontSize: 15,
            decorationStyle: ``,
            color: ``,
            pageBreak: ``,
            bold: false,
            decorationColor: ``,
          },
          {
            fontSize: 15,
            preserveLeadingSpaces: true,
            bold: false,
            decorationColor: ``,
            pageBreak: ``,
            width: 10,
            alignment: `left`,
            decorationStyle: ``,
            decoration: ``,
            color: ``,
            text: ``,
          },
          {
            stack: [
              {
                text: props.items?.absenceEndDate ? props.items?.absenceEndDate : " ",
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `center`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, -15],
              },
              {
                text: `.........................`,
                color: ``,
                width: `auto`,
                decorationColor: ``,
                alignment: `left`,
                pageBreak: ``,
                decoration: ``,
                bold: false,
                decorationStyle: ``,
                fontSize: 15,
                preserveLeadingSpaces: true,
                margin: [0, 0, 0, 0],
              },
            ],
            width: `auto`,
          },
        ],
      },
      {
        alignment: `left`,
        color: ``,
        decorationColor: ``,
        pageBreak: ``,
        preserveLeadingSpaces: true,
        decorationStyle: ``,
        decoration: ``,
        width: `auto`,
        text: ` `,
        fontSize: 15,
        bold: false,
      },
      {
        width: `auto`,
        text: ` `,
        alignment: `left`,
        decorationStyle: ``,
        pageBreak: ``,
        decorationColor: ``,
        color: ``,
        decoration: ``,
        fontSize: 15,
        bold: false,
        preserveLeadingSpaces: true,
      },
      {
        decorationColor: ``,
        text: ` `,
        alignment: `left`,
        bold: false,
        decoration: ``,
        color: ``,
        preserveLeadingSpaces: true,
        width: `auto`,
        decorationStyle: ``,
        pageBreak: ``,
        fontSize: 15,
      },
      {
        text: ` `,
        decorationStyle: ``,
        alignment: `left`,
        bold: false,
        decorationColor: ``,
        color: ``,
        decoration: ``,
        fontSize: 15,
        preserveLeadingSpaces: true,
        pageBreak: ``,
        width: `auto`,
      },
      {
        color: ``,
        decorationColor: ``,
        width: `auto`,
        fontSize: 15,
        preserveLeadingSpaces: true,
        bold: false,
        alignment: `left`,
        pageBreak: ``,
        decorationStyle: ``,
        text: ` `,
        decoration: ``,
      },
      {
        columns: [
          {
            color: ``,
            width: `auto`,
            alignment: `left`,
            pageBreak: ``,
            preserveLeadingSpaces: true,
            fontSize: 15,
            text: `Physician’s Signature`,
            decoration: ``,
            decorationStyle: ``,
            decorationColor: ``,
            bold: false,
          },
          {
            color: ``,
            width: 30,
            bold: false,
            decoration: ``,
            alignment: `left`,
            text: ``,
            decorationStyle: ``,
            fontSize: 15,
            decorationColor: ``,
            preserveLeadingSpaces: true,
            pageBreak: ``,
          },
          {
            decorationStyle: ``,
            preserveLeadingSpaces: true,
            decoration: ``,
            pageBreak: ``,
            text: `.............................................................`,
            color: ``,
            bold: false,
            fontSize: 15,
            alignment: `center`,
            decorationColor: ``,
            width: `auto`,
          },
          {
            color: ``,
            decorationColor: ``,
            pageBreak: ``,
            decoration: ``,
            decorationStyle: ``,
            bold: false,
            text: ``,
            width: 30,
            preserveLeadingSpaces: true,
            alignment: `left`,
            fontSize: 15,
          },
          {
            decorationColor: ``,
            decorationStyle: ``,
            bold: false,
            width: `auto`,
            decoration: ``,
            color: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            pageBreak: ``,
            text: ` Medical License No. `,
            alignment: `left`,
          },
          {
            decorationColor: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            decoration: ``,
            width: 15,
            color: ``,
            pageBreak: ``,
            fontSize: 15,
            bold: false,
            decorationStyle: ``,
            text: ``,
          },
          {
            text: props.items?.doctorCertNumber
              ? props.items?.doctorCertNumber
              : "                    ",
            bold: false,
            alignment: `center`,
            decoration: `underline`,
            decorationColor: ``,
            pageBreak: ``,
            decorationStyle: `dotted`,
            color: ``,
            fontSize: 15,
            preserveLeadingSpaces: true,
            width: `auto`,
          },
        ],
      },
      {
        columns: [
          {
            text: ``,
            decorationColor: ``,
            fontSize: 15,
            decoration: ``,
            preserveLeadingSpaces: true,
            alignment: `left`,
            color: ``,
            decorationStyle: ``,
            bold: false,
            pageBreak: ``,
            width: 144,
          },
          {
            decorationStyle: ``,
            pageBreak: ``,
            text: `(${props.items?.doctorNameEn})`,
            color: ``,
            fontSize: 15,
            width: `auto`,
            preserveLeadingSpaces: true,
            alignment: `center`,
            bold: false,
            decoration: ``,
            decorationColor: ``,
          },
        ],
      },
    ],
    pageSize: `A4`,
    pageOrientation: `portrait`,
    header: props.header,
    footer: props.footer,
  };
}
